import React from 'react';
import cn from 'bem-cn';

import './WelcomeSection.scss';

import { Stack, Video } from '../UI';
import { ScreenSize, useGetScreenSize } from '../../hooks';
import { Feed } from '../Feed';
import { useGetPopularPromptsQuery } from '../../store';
import { ProfileCard } from '../ProfileCard/ProfileCard';
import { useUserContext } from '../../contexts';
import { useNumberOfPopularPrompts } from './WelcomeSection.hooks';

const b = cn('welcome-section');

export const WelcomeSection: React.FC = () => {
    const { user } = useUserContext();
    const numberOfPopularPrompts = useNumberOfPopularPrompts();

    const screenSize = useGetScreenSize();
    const isMobile = screenSize === ScreenSize.Mobile;

    const { data: popularPrompts, isFetching, error } = useGetPopularPromptsQuery();

    return (
        <Stack className={b()}>
            <div className={b('background')}>
                <Video
                    className={b('video')}
                    src="https://yastatic.net/s3/distribution/prompthub/main/flower.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                    disablePictureInPicture
                />
                <div className={b('video-overlay')} />
            </div>
            <div className={b('content')}>
                <div className={b('text-block')}>
                    <div className={b('title')}>
                        <div className={b('word1')}>давайте</div>
                        <div className={b('word2')}>делать всё</div>
                        <div className={b('word3')}>с&nbsp;нейросетями</div>
                    </div>
                    {isMobile ? (
                        <p className={b('description')}>
                            Место обмена идеями, как использовать
                            <br />
                            Алису&nbsp;AI&nbsp;и&nbsp;другие нейросети
                        </p>
                    ) : (
                        <p className={b('description')}>
                            Место обмена идеями, как использовать
                            <br />
                            Алису AI&nbsp;и&nbsp;другие нейросети
                        </p>
                    )}
                </div>

                <Stack className={b('cards')} direction="row" spacing={16}>
                    {Boolean(numberOfPopularPrompts) && !error && (
                        <div className={b('popular')}>
                            <h2 className={b('popular-title')}>Топ за неделю</h2>
                            <Feed
                                containerClassName={b('popular-feed', { loaded: !isFetching })}
                                isLoading={isFetching}
                                withHover={false}
                                prompts={popularPrompts?.slice(0, numberOfPopularPrompts) || []}
                                columns={numberOfPopularPrompts}
                                itemsSize="small"
                                isPopularSection
                            />
                        </div>
                    )}
                    {user.isAuth && !isFetching && (
                        <div className={b('profile')}>
                            <h2 className={b('profile-title')}>Ваш ИИндекс</h2>
                            <ProfileCard />
                        </div>
                    )}
                </Stack>
            </div>
        </Stack>
    );
};
